"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabsContext = void 0;
const sheet_db_1 = require("../../sheet_db");
const utils_1 = require("../../utils");
const map_utils_1 = require("../../utils/map.utils");
const extractor_service_1 = require("../extractor.service");
class TabsContext {
    currentTab;
    tabsByName = new Map();
    tabsById = new Map();
    constructor({ currentTabId, tabs }) {
        const copiedTabs = JSON.parse(JSON.stringify(tabs.map(t => ({ id: t.id, name: t.name, schema: t.schema ?? [] }))));
        (0, utils_1.makeTabNamesUnique)(copiedTabs);
        copiedTabs.forEach(tab => {
            const tabSchema = TabsContext.mapToTabSchema(tab);
            this.tabsByName.set(tab.name, tabSchema);
            this.tabsById.set(String(tab.id), tabSchema);
        });
        this.currentTab = this.tabsById.get(String(currentTabId));
        if (!this.currentTab)
            throw new Error('Current tab not found');
    }
    static buildEmpty() {
        const tab = {
            id: 1,
            name: '',
            schema: [],
        };
        return new TabsContext({
            currentTabId: 1,
            tabs: [tab],
        });
    }
    static buildDataFromJSonSchema(schema = {}, prefix) {
        const parsedPrefix = prefix ? `${prefix}.` : '';
        const tabSchema = extractor_service_1.ExtractorService.extractKeys(schema.properties).map(key => ({
            column_id: key.path,
            name: `${parsedPrefix}${key.path}`,
            type: extractor_service_1.ExtractorService.mapJSonTypeToColumnType(key.type),
            node_type: sheet_db_1.NodeType.SOURCE,
        }));
        const tab = {
            id: 1,
            name: '',
            schema: tabSchema,
        };
        return {
            currentTabId: tab.id,
            tabs: [tab],
        };
    }
    static buildDataFromBqTable(bqSchema) {
        const tab = {
            id: 1,
            name: '',
            schema: bqSchema.map(utils_1.datasetColumnToColumnSchema),
        };
        return {
            currentTabId: 1,
            tabs: [tab],
        };
    }
    getTabByName(tabName) {
        const tab = this.tabsByName.get(tabName);
        return tab;
    }
    getTabById(tabId) {
        const tab = this.tabsById.get(tabId);
        return tab;
    }
    getCurrentTab() {
        return this.currentTab;
    }
    getTabs() {
        return [...this.tabsById.values()];
    }
    getCurrentTabColumns() {
        return [...this.currentTab.columnsById.values()];
    }
    getTabColumns(tabName) {
        const tab = this.getTabByName(tabName);
        if (!tab)
            return [];
        return [...tab.columnsById.values()];
    }
    getColumnByName(columnName, tabName) {
        const tab = tabName ? this.getTabByName(tabName) : this.currentTab;
        if (!tab)
            return;
        const column = tab.columnsByName.get(columnName);
        return column;
    }
    getColumnById(columnId, tabId) {
        const tab = tabId ? this.getTabById(tabId) : this.currentTab;
        if (!tab)
            return;
        const column = tab.columnsById.get(columnId);
        return column;
    }
    static mapToTabSchema({ id, name, schema }) {
        const columns = (0, utils_1.makeColumnNamesUnique)(schema);
        return {
            id: String(id),
            name,
            columnsById: map_utils_1.MapUtils.arrayToMap(columns, 'column_id'),
            columnsByName: map_utils_1.MapUtils.arrayToMap(columns, 'name'),
        };
    }
}
exports.TabsContext = TabsContext;
